module.exports = "#version 300 es\nprecision highp float;\n\nin vec2 fs_UV;\nout vec4 out_Col;\n\nuniform sampler2D u_frame0; //Scene\nuniform sampler2D u_frame1; //Scene\nuniform float u_Time;\n\nfloat LinearDepth(float d)\n{\n\tfloat f= 1000.0;\n\tfloat n = 0.1;\n\treturn (2.0 * n) / (f + n - d * (f - n));\n}\n\n\nvoid main() {\n\tvec2 ReUV = vec2(fs_UV.x, 1.0 - fs_UV.y);\n\t\n\tout_Col = texture(u_frame0, fs_UV);\n\t\n\tout_Col.w = 1.0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/present-frag.glsl
// module id = 43
// module chunks = 0